import { useState } from 'react';
import toast from 'react-hot-toast';
import { toggleBloqueoTramite } from '@/services/tramiteService';
import { reportApiError } from '@/common/utils/apiError';
import type { Tramite } from '@/types';

interface ToggleBloqueoParams {
  id: number;
  bloqueado: boolean;
  motivo?: string;
}

export function useToggleBloqueoTramite(onSuccess?: (tramite: Tramite) => void) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const toggle = async ({ id, bloqueado, motivo }: ToggleBloqueoParams): Promise<Tramite> => {
    setIsSubmitting(true);
    try {
      const updated = await toggleBloqueoTramite({ id, bloqueado, motivo });
      toast.success(bloqueado ? 'Escritura bloqueada' : 'Escritura desbloqueada');
      onSuccess?.(updated);
      return updated;
    } catch (error) {
      const info = reportApiError(error, {
        operation: 'tramite:toggle-bloqueo',
        extra: { tramiteId: id, bloqueado },
      });

      if (!info.isCanceled) {
        toast.error(`No se pudo actualizar el bloqueo de la escritura. ${info.message}`);
      }

      throw error;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { toggle, isSubmitting };
}

export default useToggleBloqueoTramite;
